<template>
  <v-container class="container-card">
    <v-card>
      <Tabela />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Tabela from "@/components/sistema/statusCampanha/Tabela";
export default {
  name: "ConsultaStatusCampanha",

  components: {
    Tabela
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Status Campanha");
  }
};
</script>
